export const footerLinks = [
    {
        url: 'https://www.your.weir/site-information/terms-of-conditions',
        name: 'Terms & Conditions',
    },
    {
        url: 'https://www.your.weir/site-information/privacy-statement',
        name: 'Privacy Statement',
    },
    {
        url: 'https://www.your.weir/site-information/cookies-policy',
        name: 'Cookies Policy',
    },
]
